import type { Logger } from './types';

export function createLogger(debug: boolean): Logger {
  return {
    debug: debug ? (...args) => console.debug('[VLT]', ...args) : () => undefined,
    info: (...args) => console.info('[VLT]', ...args),
    warn: (...args) => console.warn('[VLT]', ...args),
    error: (...args) => console.error('[VLT]', ...args),
  };
}
